import React from 'react';
import { AccountOverviewData } from '../../../types/analytics.types';
import { fmt, formatCurrency } from '../../../utils/formatters';

interface Props {
  data: AccountOverviewData;
  allTimeBalance: number;
}

const AccountOverview: React.FC<Props> = ({ data, allTimeBalance }) => {
  return (
    <div className="analytics-section">
      <h3 className="analytics-section-title">Account Overview</h3>
      <div className="account-overview-stack">
        <div className="overview-row">
          <span className="overview-label">Total Invested</span>
          <span className="overview-value">${fmt(data.initialCapital, 0)}</span>
        </div>
        <div className="overview-row">
          <span className="overview-label">Current Balance</span>
          <span className={`overview-value ${allTimeBalance >= data.initialCapital ? 'positive' : 'negative'}`}>
            ${fmt(allTimeBalance)}
          </span>
        </div>
        {data.navPerUnit !== undefined && (
          <div className="overview-row">
            <span className="overview-label">NAV per Unit</span>
            <span className={`overview-value ${data.navPerUnit >= 1 ? 'positive' : 'negative'}`}>
              ${data.navPerUnit.toFixed(6)}
            </span>
          </div>
        )}
        <div className="overview-row highlight">
          <span className="overview-label">Period P/L</span>
          <span className={`overview-value ${data.netPL >= 0 ? 'positive' : 'negative'}`}>
            {data.netPL >= 0 ? '+' : ''}{formatCurrency(data.netPL)}
          </span>
        </div>
        <div className="overview-row">
          <span className="overview-label">Period Return</span>
          <span className={`overview-value ${data.returnPct >= 0 ? 'positive' : 'negative'}`}>
            {data.returnPct >= 0 ? '+' : ''}{fmt(data.returnPct)}%
          </span>
        </div>
        <div className="overview-row">
          <span className="overview-label">Record</span>
          <span className="overview-value">
            {data.totalTrades} trades — {data.wins}W/{data.losses}L — {fmt(data.winRate, 1)}% WR
          </span>
        </div>
      </div>
    </div>
  );
};

export default AccountOverview;
